import { Panel } from "@/components/admin/AdminUI";
import { formatDate } from "@/lib/format";

function Fact({ label, children, testId }) {
  return (
    <div className="py-3" data-testid={testId}>
      <dt className="cw-muted text-xs">{label}</dt>
      <dd className="mt-1 break-words text-sm">{children ?? "—"}</dd>
    </div>
  );
}

export default function UserFacts({ user }) {
  const elig = user.signup_eligibility || {};
  const legal = user.legal_accepted || {};
  return (
    <Panel className="p-6" data-testid="user-facts">
      <h2 className="mb-2 font-semibold">Details</h2>
      <dl className="grid gap-x-8 sm:grid-cols-2 lg:grid-cols-3">
        <Fact label="Date of birth" testId="user-fact-dob">{user.dob}</Fact>
        <Fact label="Joined" testId="user-fact-created">{formatDate(user.created_at)}</Fact>
        <Fact label="Last sign-in" testId="user-fact-last-login">{formatDate(user.last_login_at)}</Fact>
        <Fact label="Recovery email" testId="user-fact-email">
          {user.recovery_email ? `${user.recovery_email}${user.recovery_email_verified_at ? " (verified)" : " (unverified)"}` : "None"}
        </Fact>
        <Fact label="Signup area" testId="user-fact-eligibility">
          {elig.location?.zip || elig.stated_zip || "—"} · {elig.status || "—"}{elig.region_label ? ` · ${elig.region_label}` : ""}
        </Fact>
        <Fact label="Super Crush balance" testId="user-fact-super-crush">{user.super_crush_balance ?? 0}</Fact>
        <Fact label="Accepted Terms / Privacy" testId="user-fact-legal">
          v{legal.terms?.version ?? "—"} / v{legal.privacy?.version ?? "—"}
        </Fact>
        <Fact label="Last phone change" testId="user-fact-phone-change">{formatDate(user.last_phone_change_at)}</Fact>
        <Fact label="Ban reason" testId="user-fact-ban-reason">{user.ban_reason}</Fact>
        <Fact label="Deleted / purge after" testId="user-fact-deleted">
          {user.deleted_at ? `${formatDate(user.deleted_at, false)} / ${formatDate(user.purge_after, false)}` : "—"}
        </Fact>
        <Fact label="Devices" testId="user-fact-devices">{(user.device_ids || []).join(", ") || "—"}</Fact>
        <Fact label="Previous numbers" testId="user-fact-phone-history">
          {(user.phone_history || []).map((p) => p.phone).join(", ") || "—"}
        </Fact>
      </dl>
    </Panel>
  );
}
